var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled, { css } from "styled-components";
import { forBp } from "@gw/theming";
import { NSStyles } from "@gw/theming";
export var AlertsContainer = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  text-align: center;\n  position: fixed;\n  width: 100%;\n  top: 80px;\n  left: 0;\n  z-index: ", ";\n\n  ", "\n"], ["\n  text-align: center;\n  position: fixed;\n  width: 100%;\n  top: 80px;\n  left: 0;\n  z-index: ", ";\n\n  ",
    "\n"])), function (_a) {
    var theme = _a.theme;
    return theme.z.modal + 10;
}, forBp(NSStyles.TBreakPoint.desktop_sm, css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      padding-left: 240px;\n    "], ["\n      padding-left: 240px;\n    "])))));
var templateObject_1, templateObject_2;
//# sourceMappingURL=AlertsContainer.js.map